module.exports = "/_next/static/images/logo-large-e60231b17b9e13fb913006976298a916.png";